import { create } from 'zustand'

interface DataPendingSendState {
    // tengo data pendiente a enviar?
    havePendingData: boolean
    setHavePendingData: (value: boolean) => void

    // total de elementos pendientes (modal)
    progressTotalModal: number
    setProgressTotalModal: (total: number) => void

    // total de elementos pendientes (se calcula cada 30s)
    pendingsSend: number
    setPendingsSend: (pendings: number) => void

    // progress calculado
    progress: number
    setProgress: (progress: number) => void

}

export const useDataPendingSendStore = create<DataPendingSendState>((set, get) => ({
    havePendingData: false, // FALSE
    setHavePendingData: (value) => set({ havePendingData: value }),

    progressTotalModal: 0,
    setProgressTotalModal: (total) => set({ progressTotalModal: total }),

    pendingsSend: 0,
    setPendingsSend: (pendings) => set({ pendingsSend: pendings }),

    progress: 0,
    setProgress: (progress) => set({ progress })

}))